import { render, staticRenderFns } from "./DepartureCities.vue?vue&type=template&id=22f37475&scoped=true&"
import script from "./DepartureCities.vue?vue&type=script&lang=js&"
export * from "./DepartureCities.vue?vue&type=script&lang=js&"
import style0 from "./DepartureCities.vue?vue&type=style&index=0&id=22f37475&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f37475",
  null
  
)

export default component.exports